import styled from "styled-components";
import TextField, { TextFieldProps } from "../atoms/TextField";
import Colours from "../atoms/Colours";


export const DateInputField = styled(TextField)<TextFieldProps>`
  opacity: 1 !important;
  input {
    border: 1px solid ${Colours.darkGrey} !important;
  }
`
